module.exports = __webpack_public_path__ + "img/Emerald.09cea361.jpg";